module.exports = string => string.replace(/\s+/g, '-');
